import { useEffect, useState } from "react";
import { ScrollText } from "lucide-react";
import { adminAuditLog } from "@/lib/apiClient";

const ACTIONS = [
  { value: "", label: "All actions" },
  { value: "set_role", label: "Role changed" },
  { value: "set_level", label: "Level changed" },
  { value: "delete_user", label: "User deleted" },
  { value: "bulk_delete_users", label: "Bulk delete" },
  { value: "decide_recitation", label: "Recitation decision" },
  { value: "create_organization", label: "Organization created" },
  { value: "delete_organization", label: "Organization deleted" },
];

export default function AdminAuditLog() {
  const [action, setAction] = useState("");
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    adminAuditLog(action).then((r) => setItems(r?.items || [])).finally(() => setLoading(false));
  }, [action]);

  return (
    <div data-testid="admin-audit-log">
      <h1 className="font-heading text-2xl sm:text-3xl font-semibold text-[#1F2937] inline-flex items-center gap-2">
        <ScrollText className="w-6 h-6 text-[#064E3B]" /> Audit Log
      </h1>
      <p className="text-sm text-[#4B5563] mt-2">Who changed roles, levels, and deleted users or organizations — admin-only.</p>

      <select data-testid="audit-log-filter" value={action} onChange={(e) => setAction(e.target.value)}
        className="mt-5 px-3 py-2 rounded-xl bg-white border border-[#E7E0D2] focus:border-[#064E3B] outline-none text-sm">
        {ACTIONS.map((a) => <option key={a.value} value={a.value}>{a.label}</option>)}
      </select>

      <div className="mt-4 rounded-2xl bg-white border border-[#E7E0D2] overflow-hidden">
        {loading ? (
          <div className="p-6 text-sm text-[#4B5563]">Loading…</div>
        ) : items.length === 0 ? (
          <div className="p-6 text-sm text-[#4B5563]">No matching actions yet.</div>
        ) : (
          items.map((r) => (
            <div key={r.log_id} data-testid={`audit-row-${r.log_id}`} className="px-5 py-3 border-b border-[#E7E0D2] last:border-b-0 flex items-start justify-between gap-3 flex-wrap">
              <div>
                <div className="text-sm text-[#1F2937]">
                  <span className="font-medium">{r.actor?.name || r.actor_user_id}</span>
                  {" "}{r.action.replace(/_/g, " ")}
                  {r.target_id && <span className="text-[#4B5563]"> · {r.target_type} {r.target_id}</span>}
                  {r.detail && <span className="text-[#4B5563]"> → {r.detail}</span>}
                </div>
                {r.actor?.email && <div className="text-xs text-[#9CA3AF] mt-0.5">{r.actor.email}</div>}
              </div>
              <div className="text-xs text-[#9CA3AF] whitespace-nowrap">{new Date(r.created_at).toLocaleString()}</div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
